import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export const SolutionSection = memo(function SolutionSection() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-197">
      <div className="max-w-3xl mx-auto" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-199">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-200">
            💡 Por eso creamos
          </h2>
          <h3 className="text-4xl md:text-6xl font-black text-red-600 mb-8 drop-shadow-sm" data-id="element-201">
            ❤️ PACK 100 CITAS
          </h3>

          <div className="bg-white p-8 rounded-2xl shadow-xl border-2 border-dashed border-blue-200 mb-12" data-id="element-202">
            <p className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-203">
              Momentos guiados, listos para usar, que transforman tiempo
              ordinario en recuerdos que tus hijos van a guardar para siempre.
            </p>
            <ul className="text-left space-y-4 text-lg text-gray-600 max-w-xl mx-auto font-medium" data-id="element-204">
              <li className="flex items-start gap-3" data-id="element-205">
                <span className="text-red-500" data-id="element-206">❌</span> No es un libro teórico
                que junta polvo.
              </li>
              <li className="flex items-start gap-3" data-id="element-207">
                <span className="text-red-500" data-id="element-208">❌</span> No es un manual largo
                que nunca vas a terminar de leer.
              </li>
              <li className="flex items-start gap-3 text-gray-900 font-bold bg-yellow-100 p-2 rounded" data-id="element-209">
                <span className="text-green-500" data-id="element-210">✅</span> Es un sistema
                práctico de citas y actividades que podés usar hoy mismo, sin
                preparar nada.
              </li>
            </ul>
          </div>

          <h3 className="text-3xl font-black text-gray-900 mb-10" data-id="element-211">
            Así de simple funciona
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-212">
            <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-blue-500" data-id="element-213">
              <div className="text-4xl mb-4" data-id="element-214">📖</div>
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-215">
                Abrís el libro
              </h4>
              <p className="text-gray-600" data-id="element-216">
                Sin complicaciones.
                <br data-id="element-217" />
                Sin preparar nada.
                <br data-id="element-218" />
                Listo en segundos.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-yellow-500 relative" data-id="element-219">
              <div className="absolute -right-4 top-1/2 transform -translate-y-1/2 hidden md:block text-gray-300 text-4xl" data-id="element-220">
                ➔
              </div>
              <div className="text-4xl mb-4" data-id="element-221">👆</div>
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-222">
                Elegís una cita
              </h4>
              <p className="text-gray-600" data-id="element-223">
                Actividades diseñadas para cada vínculo: mamá-hija, papá-hijo y
                más.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border-t-4 border-red-500 relative" data-id="element-224">
              <div className="absolute -left-4 top-1/2 transform -translate-y-1/2 hidden md:block text-gray-300 text-4xl" data-id="element-225">
                ➔
              </div>
              <div className="text-4xl mb-4" data-id="element-226">❤️</div>
              <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-227">
                Creás el recuerdo
              </h4>
              <p className="text-gray-600" data-id="element-228">
                Sin pantallas.
                <br data-id="element-229" />
                Sin estrés.
                <br data-id="element-230" />
                <span className="font-bold text-red-600" data-id="element-231">
                  Solo vos y tus hijos, conectando de verdad.
                </span>
              </p>
            </div>
          </div>

          <CTAButton text="👉 QUIERO EMPEZAR A CREAR RECUERDOS HOY" data-id="element-232" />
        </motion.div>
      </div>
    </section>;
});